import { memo, useState, useEffect } from 'react';
import { Box, Flex, useMediaQuery, Button } from '@chakra-ui/react';
import { useSelector, useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';

import { FetchModelBlocks, getBlocks, GetUserModels, resetBlock } from 'redux/ModelsSlice';
import { fetchAllScenarios } from 'redux/ScenarioSlice';
import { handleBuilderModeTab } from 'redux/BuilderModeSlice';
import useDocumentTitle from 'hooks/useDocumentTitle';
import GridMenuIcon from 'components/Icons/GridMenuIcon';
import { UserModalNew } from 'pages/UserManagement/ProfileNewUIRevamp';

import LogoSection from './components/LogoSection';
import NavigationBar from './components/NavigationBar';
import UserActions from './components/UserActions';
import MobileNavigationMenu from './components/MobileNavigationMenu';
import TabContent from './components/TabContent';
import useActiveTab from './hooks/useActiveTab';
import { HEADER_CONFIG } from './constants';

const ModalOverViewPageHeaderV1 = () => {
  const { modelId } = useParams();
  const dispatch: any = useDispatch();
  const model = useSelector(getBlocks);
  const { activeTab, setActiveTab } = useActiveTab('dashboard');
  const [isTablet] = useMediaQuery('(max-width: 1260px)');
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useDocumentTitle(model?.name);

  useEffect(() => {
    dispatch(GetUserModels({}));
  }, [dispatch]);

  useEffect(() => {
    dispatch(FetchModelBlocks({ modelId: Number(modelId), loader: true }));
    if (modelId) {
      dispatch(fetchAllScenarios(Number(modelId)));
    }
  }, [modelId, dispatch]);

  useEffect(() => {
    return () => {
      dispatch(handleBuilderModeTab(0));
      dispatch(resetBlock());
    };
  }, [dispatch]);

  const showTabletMenu = Boolean(isTablet);

  return (
    <Box bg='gradient.body' minH='100vh'>
      {/* Header */}
      <Flex
        w='100%'
        h={HEADER_CONFIG.HEIGHT}
        minH={HEADER_CONFIG.HEIGHT}
        px={6}
        py={3}
        alignItems='center'
        justifyContent='space-between'
        bg={HEADER_CONFIG.BG_COLOR}
        boxShadow='sm'
      >
        <LogoSection modelName={model?.name} modelData={model} />
        {!showTabletMenu && <NavigationBar activeTab={activeTab} onTabChange={setActiveTab} />}
        <Flex alignItems='center' gap={2}>
          {showTabletMenu && (
            <Button
              variant='solid'
              bg='white'
              borderRadius='full'
              width='40px'
              height='40px'
              minW='40px'
              p={0}
              _hover={{ bg: 'gray.50' }}
              aria-label='Open navigation menu'
              onClick={() => setIsMenuOpen(true)}
              display='flex'
              alignItems='center'
              justifyContent='center'
            >
              <GridMenuIcon width={20} height={20} color='black' />
            </Button>
          )}
          {!showTabletMenu && <UserActions />}
        </Flex>
      </Flex>

      {/* Content Section */}
      <TabContent activeTab={activeTab} blocks={model?.blocks} />

      {/* Mobile Navigation Menu */}
      {showTabletMenu && (
        <MobileNavigationMenu
          isOpen={isMenuOpen}
          onClose={() => setIsMenuOpen(false)}
          activeTab={activeTab}
          onTabChange={setActiveTab}
        />
      )}

      {/* User Modals */}
      <UserModalNew />
    </Box>
  );
};

export default memo(ModalOverViewPageHeaderV1);
